<template>
    <div>
        <template class="table-head" >

            <el-table :data="invoiceLists" border height="460" ref="dragTable">
                <el-table-column show-overflow-tooltip :prop="item.prop" :label="item.label" v-for="(item, index) in invoiceItems"
                    :key="index" >
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="160">
                    <template slot-scope="scope">
                        <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">修改</el-button> -->
                        <el-button @click="previewClick(scope.row)" type="text"  size="small">预览</el-button>
                        <el-button @click="cellClick(scope.row)" v-show="showDelBtn(scope.row)"  type="text" :disabled="isInvose"  size="small">删除</el-button>
                        <el-button @click="handleRedOffset(scope.row)"  type="text" :disabled="redOffsetBtnDisabled || !([40, '40'].includes(scope.row.makeInvoiceStatus))"  size="small">红冲</el-button>
                        <!-- <el-button v-if="false" @click="handleReopen(scope.row)"  type="text" :disabled="reopenBtnDisabled && !([80, '80'].includes(scope.row.makeInvoiceStatus))"  size="small">重开</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </template>
    </div>
</template>

<script>
import { BILLSTATUS } from '../../../../utils/configuration';
export default {
    props: {
        invoiceLists: {
            type: Array
        },
        invoiceItems: {
            type: Array
        },
        invoiceStatus: { // 发票状态
            type: [String, Number]
        },
        status: { // 单据状态
            type: [String, Number]
        },
        isSmartInvoice: { // 是智慧票开票
            type: Boolean
        },
        isInvose: {
            /**
             * ( invoiceStatus = 20 部分上传  并且  status = 10 新建 ) 或者
             * ( invoiceStatus = 30 全部上传  并且  status = 10 新建 ) 或者
             * ( invoiceStatus = 10 未上传 ) 或者
             * ( status = 47 BMS审核驳回 )
             */
            type: Boolean,
            default: true
        },
        manualFlag: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isDele: false
        };
    },
    computed: {
        // 红冲发票disabled
        redOffsetBtnDisabled: function() {
            /**
             * description 可以操作
             *  1.单据状态：驳回(47)或新建;
             *  2.发票接口表的“开票状态”：已开票(40);
             *  3.智汇票开票：是
             *  4.发票状态: 部分上传、全部上传、待接收、发票驳回
             */
            return !([10, '10', 47, '47'].includes(this.status) && this.isSmartInvoice && [20, '20', 30, '30', 40, '40', 70, '70'].includes(this.invoiceStatus));
        },
        // 重开发票disabled
        reopenBtnDisabled: function() {
            /**
             * description 可以操作
             *  1.单据状态：驳回(47)或新建;
             *  2.发票接口表的“开票状态”：已红冲;
             *  3.智汇票开票：是
             */
            return !([10, '10', 47, '47'].includes(this.status) && this.isSmartInvoice);
        }
    },
    methods: {
        // 红冲
        handleRedOffset(row) {
            this.$emit('redOffset', row);
        },
        // 重开
        handleReopen(row) {
            this.$emit('reopen', row);
        },
        previewClick(row) {
            this.$emit('previewClick', row);
        },
        cellClick(row) {
            this.$emit('cellClick', row);
        },
        showDelBtn(row) {
            /**
             * 非智汇票开票（智汇票为空或者为否），不处理显示按钮;
             * 非智汇票开票（智汇票为是），有手工关联标识，显示删除按钮,无手工关联标识，不显示删除按钮;
             */
            return [1, '1'].includes(row.eisInvoicing) ? [1, '1'].includes(row.manualFlag) : true;
        }
    },
    mounted() {
    },
    watch: {
        invoiceStatus(data) {
            if (+data === BILLSTATUS.SEAL_CONFIRMATION ||
            +data === BILLSTATUS.INVOICE_WITHDRAWAL ||
            +data === BILLSTATUS.INVOICE_RETURN) {
                this.isDele = true;
            } else {
                this.isDele = false;
            }
        }
    }
};
</script>

<style lang="less">

</style>
